import { define } from "@/components/builder/utils";
import { useTemplateEngineContext } from "@/modules/cms/views/post/components/builder/compiler";

function LayoutPreview({ path }) {
  return <>
    {path}
  </>
}

export function LayoutHTML({ path }) {
  const { registerLayout } = useTemplateEngineContext()

  registerLayout(path)

  return <>
    {`{{!< ${path}}}`}
    {'<!-- line-break -->'}
  </>
}

export default define('layout', LayoutPreview, LayoutHTML)
  .tag({ children: false, attributes: 'props' })
  .build()
